/*
NOTE: This file is used to define build-time variables for the app
These variables are set in the build process and are not meant to be changed at runtime
For application configuration variables, you should use the configService instead
Details about this in README.md
*/
export const VITE_DATADOG_CLIENT_TOKEN = import.meta.env.VITE_DATADOG_CLIENT_TOKEN
export const VITE_DATADOG_SITE = import.meta.env.VITE_DATADOG_SITE
export const VITE_ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT
export const VITE_GIT_COMMIT = import.meta.env.VITE_GIT_COMMIT
